<template>
<div>
  <template v-if="showType === 2">
    <template v-if="pageType === 'password'">
    <el-alert
      title="您的密码已修改成功,请直接登录"
      type="error"
      show-icon
      :closable="false"
      style="
        color: #F56C6C;
        width: 30%;
        margin: 30px auto;
      ">
    </el-alert>
    </template>
    <template v-else-if="pageType === 'email'">
    <el-alert
      title="此邮箱作为登录名已存在，请更换邮箱或登录。"
      type="error"
      show-icon
      :closable="false"
      style="
        color: #F56C6C;
        width: 30%;
        margin: 30px auto;
      ">
    </el-alert>

    </template>
  </template>
  <div class="cont-email" v-if="showType === 0">
    <template v-if="pageType === 'password'">
      <h1>修改密码</h1>
      <div class="box">
        <h2><i class="el-icon-success" color="#13ce66" style=" color:#67C23A; margin-right: 7px;"></i>修改密码成功，以下是您的账户信息:</h2>
        <p>登录邮箱：<em>{{userInfo.email}}</em>（用于登录，接收邮件）</p>
        <p>绑定手机号：<span>{{userInfo.phone}}</span></p>
      </div>
    </template>
    <template v-else-if="pageType === 'email'">
      <h1>邮箱注册激活</h1>
      <div class="box">
        <h2><i class="el-icon-success" color="#13ce66" style=" color:#67C23A; margin-right: 7px;"></i>恭喜注册成功，以下是您的账户信息：</h2>
        <p>登录邮箱：<em>{{userInfo.email}}</em>（用于登录，接收邮件）</p>
        <p>绑定手机号：<span>{{userInfo.phone}}</span></p>
      </div>
    </template>
  </div>
  <div class="cont-email-disabled"  v-if="showType === 1">
    <template v-if="pageType === 'password'">
      <p>激活链接已失效，如需帮助。请联系我们 <span>ti_support@qianxin.com</span>，或重新提交修改密码申请</p>
    </template>
    <template v-else-if="pageType === 'email'">
      <p>激活链接已失效，如需帮助。请联系我们 <span>ti_support@qianxin.com</span>，或重新提交<router-link to="register">注册申请。</router-link></p>
    </template>
  </div>

</div>
</template>

<script>
import { User } from '@/api/api.js'
export default {
  name: '',
  data () {
    return {
      showType: '',
      pageType: '',
      userInfo: {
        email: '',
        phone: ''
      }
    };
  },
  mounted () {
    let queryForm = this.$route.query
    this.pageType = queryForm.type
    this.confirmActive(queryForm);
  },
  methods: {
    confirmActive (params) {
      /*
      11001 激活链接已失效
      11002 激活链接未失效，已完成修改密码
      "status": 10000,
      "message": "邮件激活成功",
      "data": {
          "email": "wanwenjie@qianxin.com",
          "phone": "18813146335"
      } */
      User.confirmActive(params).then(({ data }) => {
        let typeObj = {
          10000: 0,
          11001: 1,
          11002: 2
        }
        if (typeof typeObj[data.status] === 'number') {
          this.showType = typeObj[data.status]
          this.userInfo = data.data || ({})
        } else {
          this.$message.error(data.message)
        }
      })
    }
  }
};
</script>

<style lang='scss' scoped>
.cont-email{
  width: 1000px;
  margin: 0 auto;
  text-align: left;
  h1{
    margin: 40px 0 30px;
    color: #363636;
  }
  .box{
    border: 1px solid #64B974;
    background: #F5FCF8;
    padding: 40px 60px 60px;
    margin: 20px auto 60px;
    border-radius: 4px;
    h2{
      margin-bottom: 20px;
      color: #5A5F62;
    }
    p{
      line-height: 24px;
      padding-left: 24px;
      color: #8B9093;
      em{
        font-style: normal;
        color: #F2A244;
      }
      span{
        color: #0085F8;
      }
    }
  }
}
.cont-email-disabled{
  margin: 40px auto;
  span{
    color: #0000EE;
  }
}
</style>
